import { AlertsManagementListOrderKey } from '../domain';
import { useSetFilter } from '../../filter';

export const useSetAlertsManagementListOrder = () => {
  return useSetFilter(AlertsManagementListOrderKey, 'alertsManagementOrderBy', true);
};
